import React, { ElementType, ReactNode, forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';

export interface LoadingTextProps extends BoxProps<ElementType> {
  /**
   * Value in percent to display
   */
  value?: number | string;
  /**
   * Additional label before the value
   */
  label?: ReactNode;
  /**
   * Affects font size
   * @default medium
   */
  size?: 'small' | 'medium';
}

/**
 * Component displaying current state of loading
 */
export const LoadingText: React.FC<LoadingTextProps> = forwardRef(
  ({ value, children, label, size = 'medium', sx, ...rest }, ref) => {
    return (
      <Box
        sx={{
          py: 0.5,
          fontSize: '14px',
          ...(size === 'small' && {
            fontSize: '12px',
          }),
          lineHeight: '20px',
          fontWeight: '400',
          letterSpacing: '0.002em',
          textAlign: 'right',
          ...sx,
        }}
        {...rest}
        ref={ref}
      >
        {label && (
          <Box component="span" sx={{ mr: 0.5 }}>
            {label}
          </Box>
        )}
        {children || (typeof value === 'number' ? `${value} %` : value)}
      </Box>
    );
  },
);
